export default "/images/vendor/flag-icon-css/flags/4x3/co.svg?59ec93f7d718ebed3779113450fddf23";